(function () {
    'use strict';

    angular.module("imApp").factory("msgCreateService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1683,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1684,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
